import { defineComponent as Z, openBlock as a, createElementBlock as o, mergeProps as i, unref as l, renderSlot as p, createElementVNode as e, createCommentVNode as u } from "vue";
import { useScalarIcon as v } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, M = { key: 1 }, g = { key: 2 }, A = { key: 3 }, f = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconCellSignalHigh"
}, H = /* @__PURE__ */ Z({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: V, weight: n } = v(s);
    return (d, t) => (a(), o("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(V)), [
      p(d.$slots, "default"),
      l(n) === "bold" ? (a(), o("g", m, t[0] || (t[0] = [
        e("path", { d: "M172,72V200a12,12,0,0,1-24,0V72a12,12,0,0,1,24,0Zm-52,28a12,12,0,0,0-12,12v88a12,12,0,0,0,24,0V112A12,12,0,0,0,120,100ZM80,140a12,12,0,0,0-12,12v48a12,12,0,0,0,24,0V152A12,12,0,0,0,80,140ZM40,180a12,12,0,0,0-12,12v8a12,12,0,0,0,24,0v-8A12,12,0,0,0,40,180Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (a(), o("g", M, t[1] || (t[1] = [
        e("path", {
          d: "M160,60.7V208H32a8,8,0,0,1-5.66-13.66Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M198.12,25.23a16,16,0,0,0-17.44,3.46l-160,160A16,16,0,0,0,32,216H192a16,16,0,0,0,16-16V40A15.94,15.94,0,0,0,198.12,25.23ZM152,80V200H32Zm40,120H168V64l24-24Z" }, null, -1)
      ]))) : l(n) === "fill" ? (a(), o("g", g, t[2] || (t[2] = [
        e("path", { d: "M198.12,25.23a16,16,0,0,0-17.44,3.46l-160,160A16,16,0,0,0,32,216H192a16,16,0,0,0,16-16V40A15.94,15.94,0,0,0,198.12,25.23ZM192,200H168V64l24-24Z" }, null, -1)
      ]))) : l(n) === "light" ? (a(), o("g", A, t[3] || (t[3] = [
        e("path", { d: "M166,72V200a6,6,0,0,1-12,0V72a6,6,0,0,1,12,0Zm-46,34a6,6,0,0,0-6,6v88a6,6,0,0,0,12,0V112A6,6,0,0,0,120,106ZM80,146a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V152A6,6,0,0,0,80,146ZM40,186a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0v-8A6,6,0,0,0,40,186Z" }, null, -1)
      ]))) : l(n) === "regular" ? (a(), o("g", f, t[4] || (t[4] = [
        e("path", { d: "M168,72V200a8,8,0,0,1-16,0V72a8,8,0,0,1,16,0Zm-48,32a8,8,0,0,0-8,8v88a8,8,0,0,0,16,0V112A8,8,0,0,0,120,104ZM80,144a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V152A8,8,0,0,0,80,144ZM40,184a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-8A8,8,0,0,0,40,184Z" }, null, -1)
      ]))) : l(n) === "thin" ? (a(), o("g", h, t[5] || (t[5] = [
        e("path", { d: "M164,72V200a4,4,0,0,1-8,0V72a4,4,0,0,1,8,0Zm-44,36a4,4,0,0,0-4,4v88a4,4,0,0,0,8,0V112A4,4,0,0,0,120,108ZM80,148a4,4,0,0,0-4,4v48a4,4,0,0,0,8,0V152A4,4,0,0,0,80,148ZM40,188a4,4,0,0,0-4,4v8a4,4,0,0,0,8,0v-8A4,4,0,0,0,40,188Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  H as default
};
